<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt02"><div class="partHead" id="ph02"><h2 class="partNumber"><span class="bold"><span><em class="italic"><span>Part II</span></em></span></span></h2></div><div class="partBody"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416546382_pt02.vue?0540c643